import { ref, watch, nextTick } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
const searchInput = "_searchInput_7ae9i_1";
const style0 = {
  searchInput
};
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "SearchInput"
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    value: {
      type: String,
      default: ""
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    ...createTestIdProp()
  },
  emits: ["input"],
  setup(__props, { emit }) {
    const props = __props;
    const searchInputRef = ref(null);
    const search = ref("");
    const { formatTestId } = setupTestId(props);
    function handleInput(event) {
      emit("input", event.target.value);
    }
    function focusSearchInput() {
      nextTick(() => {
        if (props.showSearch) searchInputRef.value.focus();
      });
    }
    function updateSearchInput(newValue) {
      search.value = newValue;
      if (!search.value) {
        focusSearchInput();
      }
    }
    function preventClose(event) {
      if (props.showSearch) {
        event.stopPropagation();
      }
    }
    watch(
      () => props.value,
      (value) => {
        updateSearchInput(value);
      }
    );
    watch(
      () => props.showSearch,
      () => {
        focusSearchInput();
      }
    );
    return { __sfc: true, createTestIdProp, setupTestId, props, emit, searchInputRef, search, formatTestId, handleInput, focusSearchInput, updateSearchInput, preventClose };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("input", { directives: [{ name: "show", rawName: "v-show", value: _vm.showSearch, expression: "showSearch" }, { name: "model", rawName: "v-model", value: _setup.search, expression: "search" }], ref: "searchInputRef", class: _vm.$style.searchInput, attrs: { "placeholder": _vm.searchPlaceholder, "data-testid": _setup.formatTestId("searchInput"), "size": _vm.value.length || 1 }, domProps: { "value": _setup.search }, on: { "input": [function($event) {
    if ($event.target.composing) return;
    _setup.search = $event.target.value;
  }, _setup.handleInput], "click": _setup.preventClose } });
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const SearchInput = __component__.exports;
export {
  SearchInput as default
};
